import { Anchor } from "@/components/anchors-navigation";
import { useFilterStore } from "@/stores";
import { ExclamationCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const FilterButton = () => {
    const setOpen = useFilterStore((state) => state.setOpen);
    const activeFiltersCount = useFilterStore((state) => state.activeFiltersCount);
    const activeDisciplines = useFilterStore((state) => state.activeDisciplines);
    const activeSoftware = useFilterStore((state) => state.activeSoftware);
    const activeUseCases = useFilterStore((state) => state.activeUseCases);

    const [warning, setWarning] = useState<{ message: string; severity: "error" | "warning" } | null>(null);

    const { t, ready } = useTranslation(["filters"], { useSuspense: false });

    useEffect(() => {
        if (activeUseCases.length === 0 || activeDisciplines.length === 0)
            setWarning({ message: t("filters.error"), severity: "error" });
        else if (!activeSoftware || activeSoftware === "")
            setWarning({ message: t("filters.warning"), severity: "warning" });
        else setWarning(null);
    }, [activeUseCases, activeDisciplines, activeSoftware, t]);

    const renderWarning = () => {
        if (warning?.severity === "error") {
            return (
                <div className="relative ml-auto">
                    <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600" />
                </div>
            );
        } else if (warning?.severity === "warning") {
            return (
                <div className="relative ml-auto">
                    <ExclamationCircleIcon aria-hidden="true" className="size-6 text-yellow-600" />
                </div>
            );
        }

        return null;
    };

    return ready ? (
        <Anchor id="filter-modal" small static onClick={() => setOpen(true)} className="p-1">
            <span>{t("sidebar.button", { ns: "filters" })}</span>
            <div className="flex w-[30px] h-full ml-auto">
                {warning
                    ? renderWarning()
                    : activeFiltersCount > 0 && (
                          <div className="px-2 py-0.5 ml-auto text-sm bg-primary-200 text-primary-500 rounded-full font-bold">
                              {activeFiltersCount}
                          </div>
                      )}
            </div>
        </Anchor>
    ) : null;
};

export default FilterButton;
